<template>
  <v-dialog
    scrollable
    persistent
    v-model="$store.state.docsReports.docDetailDialogShow"
    max-width="1200px"
  >
    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="closeDocDetailDialog">close</v-icon>
      </v-system-bar>
      <v-card-title class="mb-0 pb-0">
        <span class="title grey--text text--darken-2">{{condominiunSel}}</span>
      </v-card-title>
      <div class="text-xs-left pl-3 ml-1 pt-2 pb-2">
        <b>•</b>
        <span
          style="text-decoration: underline;"
          class="body-2 text-xs-left grey--text text--darken-2 pl-1 ml-1 pt-1"
        >{{$store.state.docsReports.docTypeSel['docName']}}</span>
      </div>
      <v-card-text class="mt-0 pt-0">
        <v-layout row wrap pt-4>
          <v-flex xs4 px-3>
            <v-autocomplete
              ref="cboTypeDocs"

              v-model="categorySel"
              :items="$store.state.docsReports.cboTypeDocs"
              item-text="type_name"
              item-value="type_id"
              label="Trocar categoria"
              return-object
              @change="changeCategory"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs4 px-3>
            <v-select
              ref="cboTypeDocs"
              clearable
              v-model="statusFilter"
              :items="filterTypes"
              item-text="name"
              item-value="id"
              label="Filtrar por status"
              @change="changeStatus"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-data-table
          :headers="headers"
          :items="$store.state.docsReports.typesList"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">
              <!-- {{ props.item.status }} -->
              <template v-if="props.item.obtaining">
                <v-icon
                  color="#696A6D"
                  >search</v-icon
                >
              </template>
              <template v-else>
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" v-if="props.item.status == 1" color="#50ae55">check_circle</v-icon>
                  </template>
                  <span>Vigente</span>
                </v-tooltip>
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" v-if="props.item.status == 2" color="#f98c25">warning</v-icon>
                  </template>
                  <span>A vencer</span>
                </v-tooltip>
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" v-if="props.item.status == 3" color="#f2453d">not_interested</v-icon>
                  </template>
                  <span>Vencido</span>
                </v-tooltip>
                <v-tooltip right>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" v-if="props.item.status == 4" color="#2938aa">help</v-icon>
                  </template>
                  <span>Sem informação de vencimento</span>
                </v-tooltip>
              </template>
            </td>
            <td
              class="text-xs-left"
            >{{ props.item.service ? props.item.service : props.item.sub_type }}</td>
            <td class="text-xs-left">{{ props.item.validate_date | moment("DD/MM/YYYY") }}</td>
            <td
              class="text-xs-center"
            >{{ props.item.early_warning ? props.item.early_warning : props.item.alert_date }}</td>
            <td class="text-xs-left">{{ props.item.observation }}</td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="closeDocDetailDialog">Fechar</v-btn>
        <!-- <v-btn v-if="!viewForm" color="primary" flat @click="doSave">Salvar</v-btn> -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data () {
    return {
      filterTypes: [
        { name: 'Todos', id: '' },
        { name: 'Vigente', id: 1 },
        { name: 'A vencer', id: 2 },
        { name: 'Vencido', id: 3 },
        { name: 'Não recebidos', id: 4 },
        { name: 'Em obtenção', id: 5 }
      ],
      statusFilter: '',
      headers: [
        {
          text: 'Status',
          align: 'ceter',
          sortable: true,
          value: 'status'
        },
        { text: 'Documento', value: 'service' },
        { text: 'Vencimento', value: 'validate_date' },
        {
          align: 'ceter',
          text: 'Prazo de aviso do vcto.',
          value: 'early_warning'
        },
        { text: 'Observação', value: 'observation' }
      ],
      categorySel: ''
    }
  },
  props: {
    condominiunSel: String
  },
  methods: {
    changeStatus () {
      // console.log(this.statusFilter);
      this.$store.commit('docsReports/updateDocTypeSel', {
        docName: this.$store.state.docsReports.docTypeSel.docName,
        status: this.statusFilter,
        type_id: this.$store.state.docsReports.docTypeSel.type_id
      })
      this.$store.dispatch('docsReports/getDocDetails')
    },
    changeCategory () {
      // console.log(this.categorySel.type_name);
      this.$store.commit('docsReports/updateDocTypeSel', {
        docName: this.categorySel.type_name,
        status: this.statusFilter,
        type_id: this.categorySel.type_id
      })
      this.$store.dispatch('docsReports/getDocDetails')
    },
    closeDocDetailDialog () {
      this.statusFilter = ''
      this.categorySel = ''
      this.$store.dispatch('docsReports/closeDocDetailDialog')
    }
  }
}
</script>

<style>
</style>
